<template>
    <div class="tooltip-container">
      <button 
        class="tooltip-btn"
        @click="toggleTooltip"
        @mouseenter="showTooltip = true"
        @mouseleave="showTooltip = false"
        @focus="showTooltip = true"
        @blur="showTooltip = false"
        :aria-expanded="showTooltip.toString()"
        :aria-controls="tooltipId"
      >
        <i class="fas fa-info-circle text-primary" aria-hidden="true"></i>
        <span class="sr-only">More information</span>
      </button>
      
      <div 
        :id="tooltipId"
        class="tooltip-content"
        v-show="showTooltip"
        role="tooltip"
        v-if="content"
        :class="{ 'tooltip-mobile': isMobile }"
      >
        {{ content }}
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Tooltip',
    
    props: {
      content: {
        type: String,
        required: true
      },
      id: {
        type: String,
        default() {
          return `tooltip-${Math.random().toString(36).substr(2, 9)}`
        }
      }
    },
    
    data() {
      return {
        showTooltip: false,
        isMobile: false
      }
    },
  
    computed: {
      tooltipId() {
        return `tooltip-${this.id}`
      }
    },
  
    methods: {
      toggleTooltip() {
        // Only toggle on click for mobile
        if (this.isMobile) {
          this.showTooltip = !this.showTooltip;
        }
      },
      
      checkMobile() {
        this.isMobile = window.innerWidth < 768;
      }
    },
  
    mounted() {
      this.checkMobile();
      window.addEventListener('resize', this.checkMobile);
    },
  
    beforeDestroy() {
      window.removeEventListener('resize', this.checkMobile);
    }
  }
  </script>
  
  <style scoped>
  .tooltip-container {
      position: relative;
      display: inline-block;
  }
  
  .tooltip-btn {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      color: inherit;
  }
  
  .tooltip-content {
      position: absolute;
      left: 36px;
      top: 50%;
      transform: translateY(-50%);
      background: white;
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 12px;
      width: 300px;
      max-width: calc(100vw - 32px);
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
      z-index: 1000;
  }
  
  /* Mobile styles */
  .tooltip-mobile {
      left: 50%;
      top: 100%;
      transform: translateX(-50%);
      margin-top: 12px;
  }
  
  /* Desktop arrow */
  .tooltip-content:not(.tooltip-mobile)::before {
      content: '';
      position: absolute;
      left: -6px;
      top: 50%;
      transform: translateY(-50%);
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 6px solid white;
  }
  
  .tooltip-content:not(.tooltip-mobile)::after {
      content: '';
      position: absolute;
      left: -7px;
      top: 50%;
      transform: translateY(-50%);
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 6px solid #ddd;
      z-index: -1;
  }
  
  /* Mobile arrow */
  .tooltip-mobile::before {
      content: '';
      position: absolute;
      top: -6px;
      left: 50%;
      transform: translateX(-50%);
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid white;
  }
  
  .tooltip-mobile::after {
      content: '';
      position: absolute;
      top: -7px;
      left: 50%;
      transform: translateX(-50%);
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid #ddd;
      z-index: -1;
  }
  
  .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
  }
  </style>